import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { proposal } = props;

  let crumbs = [
        {name: 'Proposals', path: 'proposals'},
        {name: 'All Proposals', path: 'proposals/pending'},
        {name: '...', path: '#'},
  ];

  if (proposal != null) {
    crumbs[2] =  { name: `${proposal.title}`, path: `proposals/${proposal._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
